export const defaultConfirmationPaneCancelButtonHoveredStyles = {
  backgroundColor: "#EFEFEF"
};